import MichiUndZaphiraHochkant from "./michi-und-zaphira-hochkant.webp";
import MichiUndZaphiraVonHinten from "./michi-und-zaphira-von-hinten.webp";
import Paragraph from "../paragraph/Paragraph";
import SEO from "../seo/SEO";
import {
  Headline,
  TextMitBildLinks,
  TextMitBildRechts,
} from "../textmitbild/TextMitBild";
import { LI, UL } from "../lists/Lists";
import "./UeberMich.css";

export default function UeberMich() {
  return (
    <div className="ueber-mich">
      <SEO
        title="Über mich"
        description="Michelle Laskowski, ausgebildete Pferdeosteopathin und -physiotherapeutin aus Hamburg. Schwerpunkt: Biotensegrales Training und Hofmag."
        breadcrumbs={[
          { name: "Start", path: "/" },
          { name: "Über mich", path: "/ueber-mich" },
        ]}
      />
      <Headline level="h1">Über mich</Headline>
      <TextMitBildRechts bild={MichiUndZaphiraHochkant} alt="Michelle mit ihrer Stute Zaphira">
        <Paragraph>
          Seit ich denken kann, spielen Pferde eine zentrale Rolle in meinem
          Leben. Schon mit vier Jahren habe ich angefangen, Zeit mit diesen
          wunderbaren Tieren zu verbringen, und meine Leidenschaft für sie ist
          seitdem stetig gewachsen.
        </Paragraph>
        <Paragraph>
          Ich bin 27 Jahre alt und komme ursprünglich aus dem IT-Bereich. Durch
          mein eigenes Pferd habe ich mich immer intensiver mit der Gesundheit
          und dem Wohlbefinden der Pferde beschäftigt, bis ich mich schließlich
          entschieden habe, meine Leidenschaft zum Beruf zu machen.
        </Paragraph>
        <Paragraph>
          Nach langer Zeit habe ich mir meinen Traum erfüllt und mein erstes
          eigenes Pferd gekauft – eine außergewöhnliche Stute mit viel
          Charakter, die mich jedoch vor einige Herausforderungen gestellt hat.
          Ihre gesundheitlichen Baustellen und mein Wunsch, ihr nachhaltig
          helfen zu können, haben mich schließlich zur Pferdeosteopathie
          geführt.
        </Paragraph>
        <Paragraph>
          Heute bin ich ausgebildete Pferdeosteopathin und
          &#8209;physiotherapeutin und unterstütze Pferde dabei, sich wieder
          frei und ohne Beschwerden bewegen zu können. Dabei liegt mir nicht nur
          die Gesundheit der Pferde am Herzen, sondern auch die Zusammenarbeit
          mit ihren Menschen – denn nur gemeinsam können wir langfristig das
          Beste für unsere Pferde erreichen.
        </Paragraph>
        <Paragraph>
          Ein besonderer Schwerpunkt meiner Arbeit liegt auf Pferden mit
          Trageschwäche. Diese Pferde brauchen eine gezielte Unterstützung, um
          ihren Körper wieder in Balance zu bringen und gesunde Bewegungsmuster
          zu entwickeln. Mit viel Feingefühl und Fachwissen helfe ich deinem
          Pferd dabei, die Voraussetzungen für eine stabile und tragfähige
          Muskulatur zu schaffen. Dabei verbinde ich osteopathische Techniken
          mit individuell abgestimmten Übungen, um dein Pferd ganzheitlich zu
          stärken und langfristig zu unterstützen. Mein Ziel ist es, nicht nur
          akute Probleme zu lösen, sondern deinem Pferd nachhaltig zu mehr
          Wohlbefinden und Bewegungsfreude zu verhelfen.
        </Paragraph>
        <Paragraph>
          Ich freue mich darauf, dich und dein Pferd kennenzulernen und euch auf
          eurer Reise zu begleiten!
        </Paragraph>
      </TextMitBildRechts>
      <Headline>Aus- und Fortbildung</Headline>
      <TextMitBildLinks bild={MichiUndZaphiraVonHinten} alt="Michelle und Zaphira von hinten">
        <Paragraph>
          Mit meiner Ausbildung zur Pferdeosteopathin und
          &#8209;physiotherapeutin habe ich mir fundiertes Wissen über die
          Anatomie und Biomechanik von Pferden angeeignet. Dabei habe ich
          gelernt, wie Blockaden gelöst, Bewegungsabläufe verbessert und die
          Gesundheit langfristig gefördert werden können.
        </Paragraph>
        <Paragraph>
          Um mein Wissen stetig zu erweitern, nehme ich regelmäßig an
          Fortbildungen teil. So kann ich individuell auf die Bedürfnisse deines
          Pferdes eingehen und es optimal unterstützen.
        </Paragraph>
        <Paragraph>
          Mein Ziel ist es, dich und dein Pferd mit Fachwissen, Erfahrung und
          viel Einfühlungsvermögen zu begleiten – für ein gesundes und
          zufriedenes Miteinander.
        </Paragraph>
        <UL>
          <LI>
            Ausbildung zur Pferdeosteopathin und Pferdephysiotherapeutin (am
            FN&#8209;anerkannten Fachzentrum für Pferdeosteopathie (ZePo))
          </LI>
          <LI>
            Ausbildung zur Beraterin für Pferdefütterungsmanagement am
            IST&#8209;Studieninstitut
          </LI>
          <LI>
            Kurstag Biotensegrales Pferdetraining mit Tina Hau von Pferdekörper
            in Funktion
          </LI>
          <LI>Seminar Beratertraining Pferdefütterung</LI>
          <LI>Fortbildung Dry Needling bei Martin van den Dungen</LI>
          <LI>
            Kurstag Biotensegrales Pferdetraining mit Anna Jantscher von Horse
            Tensegrity Training
          </LI>
          <LI>
            Kurstag Biotensegrales Pferdetraining mit Veronika von Rohrscheidt
            von Pferdekörper in Funktion und Pedro Torres
          </LI>
          <LI>Kinesiotaping am Pferd bei Martin van den Dungen</LI>
          <LI>
            Tierärzte-/Therapeuten- und Trainer Kurs bei Veronika von
            Rohrscheidt von Pferdekörper in Funktion und ihrem Team -
            Intensivwoche
          </LI>
          <LI>
            Hufbearbeitung und -beurteilung mit Tierärztin Sophia Bethke
          </LI>
        </UL>
      </TextMitBildLinks>
    </div>
  );
}
